import PropTypes from 'prop-types';
import { ButtonEditSummaryItem } from './editSummaryComponents/ButtonEditSummaryItem';
import { CustomAttachmentField } from '../../../../components/incidentForm/fields/customAttachment/customAttachmentField';

export function AttachmentsComponent({ field, onEdit }) {
  return (
    <CustomAttachmentField
      readOnly
      labelDecorator={<ButtonEditSummaryItem onClick={onEdit} />}
      field={field}
      value={field.value}
    />
  );
}

AttachmentsComponent.propTypes = {
  field: PropTypes.shape({
    idInput: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.arrayOf(
      PropTypes.shape({
        fileName: PropTypes.string,
        url: PropTypes.string,
      }),
    ),
  }),
  onEdit: PropTypes.func,
};
